import { createContext } from "react";

/** Keyboard ownership changes independently of a prepared card's data. */
export const DrillKeyboardActivityContext = createContext(true);
